import { ELEMENT_TYPES } from '../types/elements';
import type { DiagramMetamodel, MetamodelShape } from '../api/metamodelsApi';

export interface MetamodelKeyword {
  keyword: string;
  baseType: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  borderRadius?: number;
  width?: number;
  height?: number;
  iconDataUrl?: string | null;
  registrySlug?: string | null;
}

export interface MetamodelContext {
  metamodelId: string | null;
  keywords: Map<string, MetamodelKeyword>;
  open: boolean;
  /** entry codes per registry slug, used by linter for registry-mismatch checks */
  registryEntries?: Map<string, Set<string>>;
}

const EXCLUDED = new Set(['arrow', 'text', 'database_shape']);

export function builtinMetamodelContext(): MetamodelContext {
  const map = new Map<string, MetamodelKeyword>();
  for (const v of Object.values(ELEMENT_TYPES) as string[]) {
    if (EXCLUDED.has(v)) continue;
    map.set(v, { keyword: v, baseType: v });
  }
  // 'database' is the user-facing DSL alias for 'database_shape'
  map.set('database', { keyword: 'database', baseType: 'database' });
  return { metamodelId: null, keywords: map, open: true };
}

export function buildMetamodelContext(
  mm: DiagramMetamodel,
  registryEntries?: Map<string, Set<string>>,
): MetamodelContext {
  const map = new Map<string, MetamodelKeyword>();
  const shapes: MetamodelShape[] = mm.shapes ?? [];
  for (const s of shapes) {
    map.set(s.keyword, {
      keyword: s.keyword,
      baseType: s.baseType,
      fill: s.fill,
      stroke: s.stroke,
      strokeWidth: s.strokeWidth,
      borderRadius: s.borderRadius,
      width: s.width,
      height: s.height,
      iconDataUrl: s.iconDataUrl ?? null,
      registrySlug: s.registrySlug ?? null,
    });
  }
  return { metamodelId: mm.id, keywords: map, open: false, registryEntries };
}
